export default __webpack_public_path__ + "static/media/application-icon-attention.5f72f0c2.svg";